import { useInstance } from '@meraki-internal/react-dependency-injection';
import { AppointmentEditorDrawer } from './AppointmentEditorDrawer';
import { useSubscription } from '@meraki-internal/state';
import { AppointmentsState, IAppointmentTrackingFrom, NEW_APPOINTMENT_ID } from './AppointmentsState';
import { AddAppointmentButton } from './AddAppointmentButton';

export const QuickAddAppointment: React.FC<{ useIcon?: boolean; trackingFrom?: IAppointmentTrackingFrom; }> = ({ useIcon, trackingFrom }) => {
    const appointmentDrawer = useInstance(AppointmentEditorDrawer);
    const appointmentState = useInstance(AppointmentsState);
    useSubscription(() => appointmentState);

    if (!appointmentState.canAdd()){
        return (<div data-type="cannot-quick-add-appointment" />);
    }

    return (
        <AddAppointmentButton
            shortLabelOnSm
            useIcon={useIcon}
            canAdd={appointmentState.canAdd()}
            onClick={() => {
                appointmentState.trackNewAppointmentOpened({from: trackingFrom});
                appointmentDrawer.open({ appointmentId: NEW_APPOINTMENT_ID, trackingFrom });
            }}
        />
    );
};
